export default __webpack_public_path__ + "static/media/Vacay-Add-Reservation.666b9312.png";